import { Component, Input, ViewChild, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { NzCascaderComponent, NzCascaderExpandTrigger } from 'ng-zorro-antd/cascader';
@Component({
    selector: 'clink-customize-cascader',
    templateUrl: './customize-cascader.component.html',
    styleUrls: ['./customize-cascader.component.less'],
})
export class CustomizeCascaderComponent implements OnChanges {
    @ViewChild(NzCascaderComponent, { static: false }) cascader: any; // 级联元素
    @Input() placeholderText = '请选择'; // 占位提示
    @Input() nzOptions: any[] = []; // 选项数据
    @Input() cascadeType = ''; // 级联类型
    @Input() cascadeLabelKey = 'title'; // 级联转换label
    @Input() cascadeChildrenKey = 'options'; // 级联转换children
    @Input() isShowSearch = false; // 是否支持搜索
    @Input() setValues = ''; // 默认值
    @Input() nzDisabled = false; // 是否禁用
    @Input() nzExpandTrigger: NzCascaderExpandTrigger = 'hover'; // 展开方式
    @Input() nzLabelProperty = 'name'; // 展示值字段
    @Input() nzValueProperty = 'name'; // 实际值字段
    @Input() isError = false; // 当前对应控件是否有错误
    @Input() errorExpression = '必填项！'; // 错误提示语
    @Output() cascadeValue = new EventEmitter(); // 发送值变更事件

    values: string[] = []; // 级联值

    constructor() {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes && changes.nzOptions) {
            if (changes.nzOptions.currentValue) {
                // 深拷贝数据 - 避免污染源数据
                const newNzOptions = JSON.parse(JSON.stringify(changes.nzOptions.currentValue));
                if (this.cascadeType === 'filter') {
                    this.nzOptions = this.rePackage(newNzOptions);
                }
                this.nzOptions = this.addLeaf(newNzOptions);
            }
        }
        if (changes && changes.setValues) {
            if (changes.setValues.currentValue && changes.setValues.currentValue.length) {
                this.values = changes.setValues.currentValue?.split(',');
            }
        }
    }

    /**
     * 二次封装数组
     *
     * @param {any[]} data
     * @return {*}  {any[]}
     * @memberof CustomizeCascaderComponent
     */
    rePackage(data: any[]): any[] {
        // 递归
        data.forEach((element) => {
            if (this.nzLabelProperty !== this.cascadeLabelKey) {
                // label标识不一致
                element[this.nzLabelProperty] = element[this.cascadeLabelKey];
                delete element[this.cascadeLabelKey];
            }
            if (this.cascadeChildrenKey !== 'children' && element[this.cascadeChildrenKey]?.length) {
                // 子集标识不相同
                element.children = element[this.cascadeChildrenKey];
                delete element[this.cascadeChildrenKey];
                this.rePackage(element.children);
            }
        });

        return data;
    }

    /**
     * 增加叶子节点标识
     *
     * @param {any[]} data
     * @return {*}  {any[]}
     * @memberof CustomizeCascaderComponent
     */
    addLeaf(data: any[]): any[] {
        data.forEach((element) => {
            if (!element.children || !element.children?.length) {
                element.isLeaf = true;
            } else {
                this.addLeaf(element.children);
            }
        });
        return data;
    }
    /**
     * 级联值变更
     */
    onChanges(values: any): void {
        this.cascadeValue.emit(values);
        this.cascader?.closeMenu();
    }
}
